import React, {useEffect, useState} from "react";
import OpsInput from "../../ops-library/ops-input";
import OpsText from "../../ops-library/ops-text";
import OpsBtn from "../../ops-library/ops-btn";
import {FaTrashCan} from "react-icons/fa6";
import {Modal} from "react-bootstrap";
import opsToast from "../../ops-library/ops-toast";
import axios from "axios";
import {BiShow} from "react-icons/bi";
import {hasRoleAccess} from "../../functions/hasRoleAccess";
import {useNavigate} from "react-router-dom";
import {LoadingSpinner} from "../LoadingSpinner";
import {opsConfirmDialog} from "../../ops-library/ops-confirm-dialog";
import {ACCESS_TOKEN_KEY} from "../../constants/constants";
import {FiFilter} from "react-icons/fi";
import OpsToast from "../../ops-library/ops-toast";
import formatDate from "../../functions/formatDate";
import OpsTable from "../../ops-library/ops-table";
import {TbRestore} from "react-icons/tb";
import ReactStars from "react-rating-stars-component";

const AdminReviews = ({sectionId, theme, user}) => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);
    const [reviews, setReviews] = useState(null)
    const [showDeleted, setShowDeleted] = useState(false)
    const [modalReviewShown, setModalReviewShown] = useState(false);
    const [loading, setLoading] = useState(true)

    const [modalData, setModalData] = useState(null);
    const navigate = useNavigate()

    useEffect(() => {
        if (!hasRoleAccess(sectionId, user.role))
            navigate("/")
        getReviews();
    }, []);

    // API functions - get/patch/restore
    // ------------------------------------------------------------------------------
    function getReviews(showDeleted = false) {
        setLoading(true)
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/reviews?includeDeleted=${showDeleted}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        axios(configuration)
            .then((result) => {
                setReviews(result.data.content)
                setLoading(false)
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
    }

    function restoreReview(id) {
        setLoading(true)
        const configuration = {
            method: "patch",
            url: `${process.env.REACT_APP_API_BASE_URL}/reviews/restore/${id}?includeDeleted=${showDeleted}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        axios(configuration)
            .then((result) => {
                if (result.data.content !== undefined) {
                    setReviews(result.data.content)
                    OpsToast(result.data.message, "success")
                }
            })
            .catch((error) => {
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
        setLoading(false)
    }

    // MODALS
    // ------------------------------------------------------------------------------
    function handleOpenModalReview(data) {
        if (data) {
            setModalData(data)
            setModalReviewShown(true);
        } else {
            setModalData(null);
            setModalReviewShown(true);
        }
    }

    function handleModalsClose() {
        setModalReviewShown(false)
        setModalData(null)
    }

    const ModalReview = ({show = false, onHide}) => {

        const [processed, setProcessed] = useState(false)

        // API functions - delete
        // ------------------------------------------------------------------------------
        function deleteReview(id) {
            setProcessed(true)
            const configuration = {
                method: 'delete',
                url: `${process.env.REACT_APP_API_BASE_URL}/reviews/${id}?includeDeleted=${showDeleted}`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }

            axios(configuration)
                .then((result) => {
                    opsToast(result?.data?.message, "success");
                    setReviews(result.data.content)
                    handleModalsClose();
                })
                .catch((error) => {
                    console.log(error)
                    opsToast(error.message, "error", "colored", true, "top-center");
                });
            setProcessed(false)
        }

        return (
            <Modal show={show} onHide={onHide} data-theme={theme} dialogClassName="custom-modal-container">
                <Modal.Header closeButton closeVariant="white"
                              className="modal-background-color">
                    <div className="fa-flex-row justify-content-between w-100 h-100">
                        <OpsText type="title" weight={700} color="primary-3" alignment="left"
                                 content={`${modalData?.name}`}/>
                        {modalData && <OpsBtn
                            icon={<FaTrashCan color="color-1" className="ops-icon-sm m-1"/>}
                            id="del-review-btn"
                            tooltipPlacement="left"
                            variant="icon me-2"
                            padding={false}
                            action={() => {
                                const actual_review = modalData;
                                handleModalsClose()
                                opsConfirmDialog(
                                    "Vymazanie recenzie",
                                    `Naozaj si prajete odstrániť recenziu?`,
                                    theme,
                                    () => deleteReview(actual_review._id),
                                    () => handleOpenModalReview(actual_review)
                                )
                            }}
                        />}
                    </div>
                </Modal.Header>

                <Modal.Body className="modal-background-color fa-flex-col align-items-center">
                    {!processed ?
                        <div className="custom-modal-content justify-content-between">
                            {/*HLAVICKA*/}
                            <div className="desktop-row-phone-col justify-content-between w-100 mb-2">
                                {modalData && <div className="fa-flex-col">
                                    <OpsText type="label" alignment="left" color="color-1"
                                             content={`Upravené: ${formatDate(modalData.updatedAt, true)}`}/>
                                    <OpsText type="label" alignment="left" color="color-1"
                                             content={`Vytvorené: ${formatDate(modalData.createdAt, true)}`}/>
                                </div>}
                            </div>

                            {/*MENO*/}
                            <div className="fa-flex-col mb-3">
                                <div className="desktop-row-phone-col justify-content-between mt-2">
                                    <OpsText type="subtitle" color="primary-3" weight={600}
                                             alignment="left"
                                             content="Hodnotenie:"/>

                                    <ReactStars
                                        count={5}
                                        edit={false}
                                        value={modalData?.rating}
                                        size={25}
                                        isHalf={true}
                                        emptyIcon={<i className="far fa-star"></i>}
                                        halfIcon={<i className="fa fa-star-half-alt"></i>}
                                        fullIcon={<i className="fa fa-star"></i>}
                                        activeColor="#ffd700"
                                    />
                                </div>
                                <OpsInput
                                    disabled
                                    id="name"
                                    label="Meno"
                                    className="color-2"
                                    value={modalData?.name}
                                />

                                <OpsInput
                                    disabled
                                    customType="textarea"
                                    id="comment"
                                    label="Recenzia"
                                    className="color-2"
                                    value={modalData?.comment}
                                />
                            </div>
                        </div>
                        :
                        <div className="custom-modal-content">
                            <LoadingSpinner/>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        )
    }


    return (
        <div className="adm-section gap-3" id="admin-concerts">
            <ModalReview show={modalReviewShown} onHide={() => handleModalsClose()}/>

            <OpsText type="title mb-3 fa-w-100" weight={700} alignment="right"
                     content="RECENZIE"/>

            {/* SPRAVA RECENZII */}
            <div className="adm-container fa-flex-col">
                <div className="fa-flex-row fa-w-100 justify-content-between px-1 py-3 ">
                    <OpsText type="normal4 mt-1" weight={700} color="primary-6" alignment="left"
                             content="Správa recenzii"/>
                    <div className="fa-flex-row">
                        {/*ZOBRAZIT AJ ZMAZANE*/}
                        <OpsBtn
                            id="tbl-filter-deleted"
                            tooltipText="Zobraziť zmazané recenzie"
                            icon={<FiFilter color={!showDeleted ? "var(--color-p-300)" : "var(--color-1)"}
                                            className="ops-icon-sm m-1"/>}
                            variant="icon mx-1"
                            backgroundColor={`${!showDeleted ? 'bg-3' : 'bg-primary-3'} border border-1`}
                            padding={false}
                            action={() => {
                                setShowDeleted(!showDeleted)
                                getReviews(!showDeleted)
                            }}
                        />
                    </div>
                </div>
                {/*HLAVNA TABUĽKA*/}
                <OpsTable
                    id="reviews"
                    name=""
                    theme={theme}
                    classname=""
                    columns={[
                        {
                            name: "Hodnotenie",
                            selector: row => row.rating,
                            sortable: true,
                            width: '12%',
                            cell: (row) => (
                                <div>
                                    <div className="phone-not-shown">
                                        <ReactStars
                                            count={5}
                                            edit={false}
                                            value={row.rating}
                                            size={25}
                                            isHalf={true}
                                            emptyIcon={<i className="far fa-star"></i>}
                                            halfIcon={<i className="fa fa-star-half-alt"></i>}
                                            fullIcon={<i className="fa fa-star"></i>}
                                            activeColor={row.deleted ? "#000000" : "#ffd700"}
                                        />
                                    </div>
                                    <div className="desktop-not-shown">
                                        <OpsText
                                            alignment="left" nowrap textEllipsis
                                            lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                            content={row.rating}
                                        />
                                    </div>
                                </div>
                            )
                        },
                        {
                            name: "Meno",
                            selector: row => row.name,
                            sortable: true,
                            width: '15%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={row.name}
                                />
                            )
                        },
                        {
                            name: "Recenzia",
                            selector: row => row.comment,
                            sortable: false,
                            width: '50%',
                            cell: (row) => (
                                <OpsText
                                    type="label8"
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted} color={row.deleted && 'color-g-2'}
                                    content={row.comment}
                                />
                            )
                        },
                        {
                            name: "Dátum vytvorenia",
                            selector: row => new Date(row.createdAt).getTime(),
                            sortable: true,
                            width: '15%',
                            cell: (row) => (
                                <OpsText
                                    alignment="left" nowrap textEllipsis
                                    lineThrough={row.deleted}
                                    color={row.deleted && 'color-g-2'}
                                    content={`${new Date(row.createdAt).toLocaleDateString('sk-SK', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric'
                                    }).replace(/\s/g, '')} - ${new Date(row.createdAt).toLocaleTimeString('sk-SK', {
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false
                                    })}`}
                                />
                            )
                        },
                        {
                            name: "",
                            sortable: false,
                            selector: null,
                            width: '5%',
                            right: true,
                            cell: (row) => [
                                !row.deleted && !row.shippingSupplement && <OpsBtn
                                    key={0}
                                    icon={<BiShow className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor={row.deleted ? "bg-g-2" : "bg-primary-3"}
                                    padding={false}
                                    action={() => handleOpenModalReview(row)}
                                />,
                                row.deleted && !row.shippingSupplement && <OpsBtn
                                    key={1}
                                    icon={<TbRestore className="ops-icon-sm"/>}
                                    variant="icon mx-1 ops-tbl-btn-icon"
                                    backgroundColor="bg-g-2"
                                    padding={false}
                                    action={() => {
                                        opsConfirmDialog(
                                            "Obnovenie recenzie",
                                            `Naozaj si prajete obnoviť recenziu?`,
                                            theme,
                                            () => restoreReview(row._id),
                                            () => null
                                        )
                                    }}
                                />
                            ]
                        }
                    ]}
                    data={loading === false ? reviews : []}
                />
            </div>
        </div>
    )
}

export default AdminReviews;